export const environment = {
  msal: {
      clientId: 'e7837f1b-2b43-4c58-bfbd-53b985da56ce',
      tenantId: '354ffbfb-e376-41b5-9059-522f3cdf73be',
      redirect: 'http://localhost:4200/callback'
  },
  graph: {
      uri: 'https://graph.microsoft.com/v1.0/me',
      scopes: ['User.Read']
  },
  graph1: {
      uri: 'https://graph.microsoft.com/v1.0/users/*',
      scopes: ['User.Read']
  },
  graph2: {
      uri: 'https://graph.microsoft.com/v1.0/groups',
      scopes: ['Group.Read.All']
  },
  env: "PROD",
  version: "1.1.0",
  gateway_url: "https://retailhubapi-gateway.azurewebsites.net",
  sectors: [
      {
          sector_name: "Innovisor",
          region_view: "single",  
          groups: [
              { name: "NA-PHC", key: "f9646414-8e80-4048-9717-06f7b45e114a",regionName:"NA" }
          ]
      }
  ]
};